import { Injectable } from '@angular/core';
import { ApolloQueryResult } from '@apollo/client/core';
import { Apollo, ApolloBase, MutationResult, gql } from 'apollo-angular';
import { Observable, map } from 'rxjs';
import { GraphqlConfigService } from './graphql-config.service';
import { GraphqlErrorInterceptor } from '../models/graphql-interface.model';
import { HeaderService } from './header.service';
@Injectable({
  providedIn: 'root'
})
export class GraphqlClientService {
  // Apollo client for the default GraphQL server
  private apolloServer1: ApolloBase;
  // Apollo client for the secondary GraphQL server (named 'server2')
  private apolloServer2: ApolloBase;
  /**
  * @param apollo - The Apollo service provided by apollo-angular for managing GraphQL  
  * operations.
  */
  constructor(private apollo: Apollo, private graphqlConfig: GraphqlConfigService, private header: HeaderService
  ) {
    this.apolloServer1 = this.apollo; // Default Apollo client
    this.apolloServer2 = this.apollo.use('server2'); // Named client 'server2'
  }
  /**
   * @param query - The GraphQL query string to execute.
   * @param variables - Optional variables to be substituted into the query.
   * @returns An Observable with the result of the query execution.
   */
  executeQuery(query: string, variables?: { [key: string]: any }, isSecondServer: boolean = false): Observable<any> {
    // const client = isSecondServer ? this.apolloServer2 : this.apolloServer1;
    const client = this.apolloServer1;
    let customHeaders = {};
    if (isSecondServer) {
      customHeaders = {
        'isnativegraphql': 'true'
      };
    } else {
      customHeaders = {
      };
    }
    return client.query({
      query: gql`${query}`,
      variables: variables,
      errorPolicy: 'all',
      context: {
        headers: customHeaders
      }
    }).pipe(
      map(this.handleResponse),
    );
  }
  /**
  * @param query - The GraphQL query as a string to execute.
  * @param variables - An optional object containing variables for the GraphQL query.
  * @returns An observable that emits query result objects.
  */
  executeWatchQuery(query: string, variables?: { [key: string]: any }, isSecondServer: boolean = false): Observable<any> {
    // const client = isSecondServer ? this.apolloServer2 : this.apolloServer1;
    const client = this.apolloServer1;
    let customHeaders = {};
    if (isSecondServer) {
      customHeaders = {
        'isnativegraphql': 'true'
      };
    } else {
      customHeaders = {
      };
    }
    return client.watchQuery({
      query: gql`${query}`,
      variables: variables,
      context: {
        headers: customHeaders
      }
    }).valueChanges.pipe(
      map(this.handleResponse),
    );
  }
  /**
   * @param mutation - The GraphQL mutation string to execute.
   * @param variables - Optional variables to be substituted into the mutation.
   * @returns An Observable with the result of the mutation execution.
   */
  executeMutation(mutation: string, variables?: { [key: string]: any }, isSecondServer: boolean = false): Observable<any> {
    // const client = isSecondServer ? this.apolloServer2 : this.apolloServer1;
    const client = this.apolloServer1;
    let customHeaders = {};
    if (isSecondServer) {
      customHeaders = {
        'isnativegraphql': 'true'
      };
    } else {
      customHeaders = {
      };
    }
    return client.mutate({
      mutation: gql`${mutation}`,
      variables: variables,
      context: {
        headers: customHeaders
      }
    }).pipe(
      map(this.handleResponse),
    );
  }
  /**
   * @param response - The response object from the Apollo query or mutation.
   * @returns The data from the response if it exists.
   * @throws An error if the response contains GraphQL errors or is unexpected.
   */
  private handleResponse(response: ApolloQueryResult<any> | MutationResult<any>): any {
    if (response && response.data && response.errors) {
      const data = response?.data ?? null;
      const errors = response.errors.reduce((acc: any, item: any) => {
        const key = item.path[0];
        acc[key] = item;
        return acc;
      }, {});
      throw { ...data, errors };
    }
    if (response && response.data) {
      return response.data;
    }
    if (response && response.errors) {
      return response.errors
    }
  }
  updateApolloGraphqlUrl(newGraphqlUrl: string, serviceClass: GraphqlErrorInterceptor, cacheNeeded: boolean = true): void {
    const newConfig = this.graphqlConfig.createApollo(serviceClass, newGraphqlUrl, cacheNeeded);
    if (newConfig.link)
      this.apollo.client.setLink(newConfig.link);
  }
}
